import React from "react";
import "./SignVtrNav.scss";
import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Grid";

const SignVtrNav = (props) => {
  const getNextButtonText = function (currentStep) {
    if (currentStep === 1 || currentStep === 2) {
      return "Next";
    }
    return "Submit";
  };

  const isNextDisabled = function (currentStep, isSigned, isDisabled) {
    if (currentStep === 1 || currentStep === 2) {
      return false;
    }
    if (isDisabled) {
      return true;
    }
    return !isSigned;
  };

  return (
    <div className="bottom-navXX SignVtrNav" data-testid="SignVtrNav">
      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto">
            <Link>
              <Button
                variant="contained"
                className="warningBtn margRight20"
                onClick={(e) => props.handleCancel(e, "Cancel")}
              >
                Cancel
              </Button>
            </Link>
          </Grid>
          {props.currentStep > 1 && (
            <Grid item xs="auto">
              <Button
                variant="contained"
                color="primary"
                className="margRight20"
                onClick={(e) => props.handleBack(e, "Back")}
              >
                Back
              </Button>
            </Grid>
          )}
          <Grid item xs="auto">
            <Button
              variant="contained"
              className={props.isDisabled ? "disabledBtn" : "successBtn"}
              onClick={(e) =>
                props.handleNext(e, getNextButtonText(props.currentStep))
              }
              disabled={isNextDisabled(
                props.currentStep,
                props.isSigned,
                props.isDisabled
              )}
            >
              {getNextButtonText(props.currentStep)}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default SignVtrNav;
